/**@format */
var jQuery = require("jquery");

/**
 * 
 * @constructor
 * @param {ViewModel} viewModel 
 */
function ServicingViewModel(viewModel) {
  this.viewModel = viewModel;
  this.activeServiceTransactionsWS = viewModel.activeServiceTransactionsWS;
  this.queuesWS = viewModel.queuesWS;
  this.messagesWS = viewModel.messagesWS;

  this.showConfirmStopService = ko.observable(false);
  this.confirmStopServiceData = ko.observable(null);

  /**
   * Do any of the selected Queues use the Next Queue feature?
   */
  this.isUsingNextQueues = ko.computed(function () {
    var queues = viewModel.queuesWS.queues();
    return queues.some(function (q) {
      return q.hasNextQueues();
    });
  }, this);

  this.mustConfirmStopService = ko.computed(function () {
    var isConfirmationRequired =
      this.messagesWS.get("nextQueue.confirmStopService.enable") === "true";
    return isConfirmationRequired;
  }, this);

  this.transactions = ko.computed(
    function () {
      var selectedLocations = this.viewModel.selectedLocationIds()
      var transactions = this.activeServiceTransactionsWS.transactions();

      return transactions
        .filter(function (t) {
          return t && t.spot && t.spot.queue();
        })
        .map(function (t) {
          var hasNextQueue =
            t.spot && t.spot.queue() ? t.spot.queue().hasNextQueues() : false;

          return {
            transaction: t,
            spot: t.spot,
            hasNextQueue: hasNextQueue,
          };
        });
    },
    this,
    { deferEvaluation: true }
  );

  /**
   * Passes on to the ViewModel.handleEndService
   * @param {object} data
   * @param {Event} event
   */
  this.handleEndService = function (data, event) {
    // Unwraps the transaction from our `activeTransactions` data that bundles it with
    // `showStopServiceButton` property
    this.viewModel.handleEndService(data.transaction, event);
  }.bind(this);

  /**
   * Stops the Service "unsuccessfully". It ends the service but it prevents the
   * Next Queue feature from triggering the "Add Consumer" prompt if the Spot
   * being serviced is in a queue with Next Queues configured.
   */
  this.handleStopService = function (data) {
    this.viewModel.endService(data.transaction.sessionId, true);

    if (this.showConfirmStopService()) {
      this.showConfirmStopService(false);
    }
  }.bind(this);

  this.handleRequeueConsumer = function (data, event) {
    this.viewModel.handleRequeueConsumer(data.transaction, event);
  }.bind(this);

  this.handleShowConfirmStopService = function (data) {
    this.confirmStopServiceData(data);
    this.showConfirmStopService(true);
  }.bind(this);

  this.handleCancelConfirmStopService = function () {
    this.confirmStopServiceData(null);
    this.showConfirmStopService(false);
  }.bind(this);

  this.handleConfirmStopService = function (data, event) {
    this.handleStopService(this.confirmStopServiceData, event);
  }.bind(this);

  this.handleStopAction = function (data, event) {
    if (this.mustConfirmStopService()) {
      this.handleShowConfirmStopService(data, event);
    } else {
      this.handleStopService(data, event);
      this.showConfirmStopService(false);
    }
  }.bind(this);

  this.confirmStopServicePrompt = ko.computed(
    function () {
      /** @var {string} */
      var message = this.messagesWS.get("nextQueue.confirmStopService.prompt");
      return message
        .replace(".", ".<br />")
        .replace(
          "[icon-next-queue]",
          '<span style="display: inline-block;" class="bluebtn stub"><i class="fa fa-step-forward"></i></span>'
        );
    },
    this,
    { deferEvaluation: true }
  );
}

module.exports = ServicingViewModel;
